// extracted by mini-css-extract-plugin
module.exports = {"mainVideo":"MainVideo_mainVideo__3puYN","mainVideoHidden":"MainVideo_mainVideoHidden__ud1HO"};